import { createSelector } from 'reselect';

import { selectSubCompany } from './subCompany.selectors';

export const selectSubCompanyLoanCount = createSelector(
  selectSubCompany,
  subCompany => subCompany?.loanCount ?? null,
);
